<template>
  <div id="tutorial-excluir-dados">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h2>
            <i class="icofont-close"></i> <strong>Excluir os seus dados</strong>
          </h2>
          <hr />
          <p>
            No <strong>eSUS Feedback</strong>, você pode realizar a exclusão da
            sua conta e dos seus dados a qualquer momento pelo aplicativo ou
            pelo sistema web.
          </p>
          <br />

          <h4><strong>Atenção!</strong></h4>
          <p>
            <cite>Ao excluir a conta</cite>, o usuário perde o acesso ao sistema
            e suas funcionalidades, entretanto você poderá acessá-lo novamente
            criando uma outra conta no momento que desejar.
          </p>
          <br />
          <h4>
            <strong> Exclusão de conta e dados no app</strong>
          </h4>
          <p>
            No aplicativo, o usuário precisa entrar com seu CPF e senha,
            conforme mostra a figura abaixo:
          </p>
          <div class="info-1">
            <div>
              <p>Login</p>
              <img
                src="@/assets/images/tutorial-excluir-conta/login.png"
                alt=""
              />
            </div>
            <div>
              <p>Clicar no perfil de usuário</p>
              <img
                src="@/assets/images/tutorial-excluir-conta/dashboard.png"
                alt=""
              />
            </div>
            <div>
              <p>E depois, clicar em Excluir conta e confirmar.</p>
              <img
                src="@/assets/images/tutorial-excluir-conta/configuracoes.png"
                alt=""
              />
            </div>
          </div>
          <br />
          <h4>
            <strong>Exclusão de conta e dados pelo sistema web</strong>
          </h4>
          <p>
            Em qualquer navegador atualizado de internet, o usuário pode acessar
            o link
            <a href="https://esusfeedback.com.br/login" target="_blank">
              https://esusfeedback.com.br/login</a
            >
            e com seu CPF e senha, pode clicar na opção excluir conta, conforme
            mostra a figura abaixo.
          </p>
          <img
            src="@/assets/images/tutorial-excluir-conta/dashboard-web.png"
            alt=""
          />
          <h4><strong>Tipos de dados que são excluídos</strong></h4>
          <p>
            São excluídos os dados constantes no formulário de cadastro
            (efetivação da conta), conforme mostra a figura abaixo.
          </p>
          <img
            src="@/assets/images/tutorial-excluir-conta/dados-conta.png"
            alt=""
          />
          <br />
          <h4><strong>Tipos de dados que são mantidos.</strong></h4>

          <p>
            Para cumprimento de obrigação legal, estabelecida pela Lei Geral de
            Proteção de Dados (LGPD), é mantido permanentemente o nome completo
            do usuário na trilha de auditoria para identificá-lo enquanto
            profissional de saúde que analisou e visualizou os dados nominais
            dos cidadãos sob seus cuidados. Isso é necessário para informar aos
            titulares de dados quem e quando seus dados foram visualizados.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Excluir os seus dados',
    titleTemplate: null,
  },
}
</script>

<style lang="scss" scoped>
#tutorial-excluir-dados {
  margin: 20px auto;
  p {
    text-align: justify;
  }
  img {
    margin: 30px auto;
    display: block;
    @media screen and (max-width: 656px) {
      width: 100%;
    }
  }
  .info-1 {
    display: flex;
    justify-content: space-between;
    text-align: center;
    @media screen and (max-width: 656px) {
      flex-direction: column;
    }
    div {
      flex: 1;
      p {
        font-weight: 700;
        margin-bottom: 0;
        font-size: 14px;
        text-align: center;
      }
      img {
        margin: 10px auto;
        @media screen and (max-width: 656px) {
          width: auto;
        }
      }
    }
  }
}
</style>
